import { createSelectors } from 'app/api/redux-jigsaw/userdata/utils/selector-utils';
import { findBookmarkForThumb } from 'app/api/redux-jigsaw/userdata/bookmarks/utils';
import { createSelector } from 'reselect';
import { getToc } from 'app/api/redux-jigsaw/toc-selectors';
import { findIndexMatchingCfiFallBackToBefore } from 'app/api/jigsaw-helpers';

const base = createSelectors('bookmarks');

export const areBookmarksPending = base.isPending;
export const hasBookmarks = base.hasItems;
export const hasBookmarkLoadError = base.hasError;

export function getBookmarkForThumb(state, thumb) {
  const bookmarks = base.getItems(state);
  return findBookmarkForThumb(bookmarks, thumb);
}

export function isBookmarkAddProcessingForThumb(state, thumb) {
  const addsInProgress = state.jigsaw.bookmarks.pending.add;
  return addsInProgress.some(
    p => p.epub_cfi === thumb.cfiref || p.pbk_label === thumb.label
  );
}

export function isBookmarkDeleteProcessingForThumb(state, thumb) {
  const deletesInProgress = state.jigsaw.bookmarks.pending.del.map(id =>
    base.getItemData(state, id)
  );
  const myBookmark = findBookmarkForThumb(deletesInProgress, thumb);
  if (myBookmark) {
    return base.isDeleteProcessing(state, myBookmark.guid);
  }
  return false;
}

export const getBookmarks = createSelector(
  state => base.getItems(state),
  state => getToc(state),
  (bookmarks, toc) => {
    return bookmarks.map(b => {
      if (b.epubCfi || b.pbkPage) {
        const cfi = b.epubCfi || `/${b.pbkPage}`;
        const index = findIndexMatchingCfiFallBackToBefore(
          toc,
          el => el.cfi,
          cfi
        );
        if (index >= 0) {
          return {
            ...b,
            chapterTitle: toc[index].title,
          };
        }
      }
      return b;
    });
  }
);



// WEBPACK FOOTER //
// ./src/app/api/redux-jigsaw/userdata/bookmarks/selectors.js